export default __webpack_public_path__ + "static/media/gallery_08.98a850d4.jpg";